import React from "react";
import Header from "./Header";
import '../../styles/TerminiCondizioniPage.scss';
import Arrow from "./Arrow";
import Footer from "./Footer";

const TerminiCondizioniPage = () => {

    return (
        <div className="termini-privacy-container">
            <Header>
                <div className='header-child'>
                    <h1 data-aos="fade-right">Termini e Condizioni di Utilizzo</h1>
                    <p data-aos="fade-up">Ultimo aggiornamento: 04/09/2024</p>
                    <Arrow data-aos="fade-in" direction="down" size="small" animated={true}/>
                </div>
            </Header>
        
            
            <div className="termini-condizioni">
                <p>
                    Benvenuto sul sito web del CosyHole ("noi", "ci" o "nostro"). Utilizzando il nostro sito web, l'utente accetta di rispettare e di essere vincolato dai seguenti termini e condizioni. Se non si è d'accordo con questi termini, si prega di non utilizzare il sito web.
                </p>

                <h2>1. Accettazione dei Termini</h2>
                <p>
                    Utilizzando il nostro sito, l'utente accetta questi Termini e Condizioni in pieno. Se non si è d'accordo con qualsiasi parte di questi Termini, non si deve utilizzare il nostro sito web.
                </p>

                <h2>2. Modifiche ai Termini</h2>
                <p>
                    Ci riserviamo il diritto di modificare questi Termini in qualsiasi momento senza preavviso. Le modifiche saranno pubblicate su questa pagina e l'uso continuato del sito web costituisce l'accettazione dei Termini aggiornati.
                </p>

                <h2>3. Uso del Sito</h2>
                <p>
                    Il sito web è disponibile per l'uso personale degli utenti per visualizzare informazioni relative al nostro pub, incluso il nostro menu e le immagini del locale. Non è consentito utilizzare il sito per scopi illegali o non autorizzati.
                </p>

                <h2>4. Proprietà Intellettuale</h2>
                <p>
                    Tutti i contenuti presenti su questo sito, inclusi testi, immagini, loghi e grafica, sono di proprietà del CosyHole o dei rispettivi proprietari e sono protetti dalle leggi sul diritto d'autore e sulla proprietà intellettuale. Non è consentito copiare, distribuire, trasmettere, visualizzare, riprodurre o creare opere derivate da alcun contenuto senza previa autorizzazione scritta.
                </p>

                <h2>5. Limitazione di Responsabilità</h2>
                <p>
                    Il contenuto di questo sito è fornito "così com'è" e "come disponibile". Non garantiamo l'accuratezza, la completezza o l'affidabilità delle informazioni fornite. Non siamo responsabili per eventuali danni derivanti dall'uso del sito web.
                </p>

                <h2>6. Collegamenti a Siti di Terzi</h2>
                <p>
                    Il nostro sito può contenere collegamenti a siti web di terzi che non sono controllati o gestiti da noi. Non siamo responsabili dei contenuti o delle pratiche di privacy di tali siti.
                </p>

                <h2>7. Privacy</h2>
                <p>
                    La nostra Politica sulla Privacy spiega come raccogliamo, utilizziamo e proteggiamo le informazioni personali degli utenti. Utilizzando il nostro sito, l'utente accetta i termini della nostra Politica sulla Privacy.
                </p>

                <h2>8. Cookie</h2>
                <p>
                    Utilizziamo i cookie per migliorare l'esperienza dell'utente sul nostro sito. Per ulteriori informazioni sui cookie che utilizziamo e su come gestirli, consultare la nostra Politica sui Cookie.
                </p>

                <h2>9. Legge Applicabile</h2>
                <p>
                    Questi Termini e Condizioni sono regolati e interpretati in conformità con le leggi italiane. 
                </p>

                <h2>10. Contatti</h2>
                <p>
                    Se hai domande o dubbi riguardanti questi Termini e Condizioni, ti preghiamo di contattarci a pedaso53@gmail.com o +39 333 335 3698.
                </p>
            </div>
            <Footer />
        </div>
        )
};

export default TerminiCondizioniPage;